/* global Symbol */
import * as syncActionCreators from '../sync';
import { push } from 'react-router-redux';

import Promise from 'bluebird';
import _ from 'lodash';


export function getJobRequestDocuments(contactId, jobId, callback) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.get({
      route: `/api/contacts/${contactId}/jobs/${jobId}/documents`
  })
  .then((resp) => {
    if(callback && callback.success)
      return callback.success(resp.body.data.items);
    return resp.body.data.items;
  }, (err) => {
    if(callback && callback.error)
      return callback.error(err)

    return err;
  })
    .catch(err => {

        if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
      return err;
    });
  };
}

export function createJobRequestDocuments(contactId, body, callback) {
  return simpleIsoFetch => dispatch => {
   return simpleIsoFetch.post({
      route: `/api/contacts/${contactId}/jobs/${body.jobId}/documents/${body.clientId}`,
    body
  })
  .then((resp) => {
    if(callback && callback.success)
      return callback.success(resp.body.data.items);
    return resp.body.data.items;
  }, (err) => {
    if(callback && callback.error)
      return callback.error(err)

    return err;
  })
    .catch(err => {
        if (!err || !~[400].indexOf(err.status)) {
          console.log(err);
      }
      return err;
    });
  };
}

export function updateJobRequestDocuments(contactId, body, callback) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.put({
      route: `/api/contacts/${contactId}/jobs/${body.jobId}/documents/${body.clientId}`,
    body
  })
  .then((resp) => {
    if(callback && callback.success)
      return callback.success(resp.body.data.items);
    return resp.body.data.items;
  }, (err) => {
    if(callback && callback.error)
      return callback.error(err)

    return err;
  })
    .catch(err => {
        if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
      return err;
    });
  };
}

export function deleteJobRequestDocuments(contactId, body, callback) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.del({
      route: `/api/contacts/${contactId}/jobs/${body.jobId}/documents/${body.clientId}`,
    body
  })
  .then((resp) => {
    if(callback && callback.success)
      return callback.success(resp.body);
    return resp.body;
  }, (err) => {
    if(callback && callback.error)
      return callback.error(err)

    return err;
  })
    .catch(err => {
        if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
      return err;
    });
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/jobrequestDocuments.js